<template>
  <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData" :isImmagini="true" :isAllegati="false" :isPrestazioni="true" :btnFirmaVisible="btnFirmaVisible" @updateFirma="onFirmaUpdate">
    <template slot="tab-content-event">
      <anorettocolonscopia-view-component @update="onUpdateJsonData" :idEvento="id" :key="anorettocolonscopiaViewKey"></anorettocolonscopia-view-component>
    </template>
  </eventi-view-component>
</template>
<script>
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import AnorettocolonscopiaViewComponent from "./AnorettocolonscopiaViewComponent.vue";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import EventiMixin from "../../../utility/mixins/EventiMixins";
export default {
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  mixins: [UtilityMixin, EventiMixin],
  components: {
    EventiViewComponent,
    AnorettocolonscopiaViewComponent,
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  data() {
    return {
      id: null,
      data: {},
      jsonData: {},
      linkback: "",
      linkedit: "",
      titoloEvento: this.$i18n.t("patients.gastroenterology.anusRectumColonoscopy"),
      showModalLoading: false,
      pathResource: "/gastroanorettocolonscopia",
      btnFirmaVisible: true,
      pathRestValidation: "/validation",
      isThisFirmato: false,
      firmaFieldName: null,
      linkPrintData: null,
      tabIndex: 0,
      anorettocolonscopiaViewKey: 0,
    };
  },
  mounted() {
    let me = this;
    me.jsonData.idPaziente = this.$route.query.idPaziente;
    me.id = this.$route.params.id;
    me.anorettocolonscopiaViewKey++;
  },
  methods: {
    updateStatoFirma(firmato) {
      console.log(firmato);
    },
    onFirmaUpdate() {
      let me = this;
      me.btnFirmaVisible = false;
      me.anorettocolonscopiaViewKey++;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
      if (me.jsonData.firma) {
        me.btnFirmaVisible = false;
      } else {
        me.btnFirmaVisible = true;
      }
      me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
    },
  },
};
</script>
